// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-input[data-v-5842d9d4] {\r\n  padding-right: 100px;\n}\n.cancel-btn[data-v-5842d9d4] {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
